// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"MessageTask_titleContainer__1ElE9","title":"MessageTask_title__1W3K9","date":"MessageTask_date__c74pt","messageContainer":"MessageTask_messageContainer__2K_mJ"};